import React from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { LoaderInformative } from 'src/shared/components';

const LoaderPage = () => {
  const loader = useSelector((state) => state.loader);

  if (!loader.isLoading && isEmpty(loader.loading)) return null;

  return <LoaderInformative loadingText={loader.loadingText} />;
};

export default LoaderPage;
